import React from "react";

import Site from "../Site/SiteContainer";
import AppProvider from "./AppProvider";

export const BASE_URLS = ["global.bible", "lvh.me", "localhost"];

export interface Props {
  hostname?: string;
}

const App: React.FC<Props> = ({ hostname = "" }) => {
  const host =
    process.env.REACT_APP_HOSTNAME_OVERRIDE ||
    hostname ||
    (document.location && document.location.hostname);

  if (BASE_URLS.includes(host) || !host) {
    return <h2>Global.Bible</h2>;
  }

  return (
    <AppProvider>
      <Site hostname={host} />
    </AppProvider>
  );
};

export default App;
